import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BillingBackToPreviousScreenService } from '../../services/billing-back-to-previous-screen.service';
import { EnvironmentService, TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-back-button',
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BackButtonComponent implements OnInit {
  constructor(
    private billingBackToPreviousScreenService: BillingBackToPreviousScreenService,
    private environmentService: EnvironmentService,
    private translationService: TranslationService
  ) {}

  @Input() customLabel?: string;
  @Input() backButtonType?:
    | 'leftArrowPlainText'
    | 'lastButton'
    | 'firstButton'
    | 'firstButtonWithLeftArrow'
    | 'firstButtonWithLeftArrowNoMarginLeft';
  @Input() shouldGoBackToOverview?: boolean;
  @Input() forceDisplayOfBackButton?: boolean;

  isNotProximusPlusMobileApp = true;
  ngOnInit() {
    this.isNotProximusPlusMobileApp = !(
      this.environmentService.isProximusPlusMobileApp &&
      this.translationService.getTranslatedValueFor(
        'bills.cover.isBackButtonsHiddenInPxPlus'
      ) === 'true'
    );
  }
  navigate() {
    this.billingBackToPreviousScreenService.goBack(this.shouldGoBackToOverview);
  }
}
